module.exports = __webpack_public_path__ + "img/westminster_b1.0fac8e08.jpg";